var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_75700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27204 5.33317C7.7236 5.33317 7.26108 5.70827 7.13016 6.21691L6.96399 6.86254L5.67274 6.53019L5.83891 5.88457C6.11777 4.80113 7.10049 3.99984 8.27204 3.99984C9.65955 3.99984 10.7844 5.12464 10.7844 6.51215C10.7844 7.26607 10.4254 7.7716 10.0166 8.16922C9.84304 8.33809 9.64516 8.50214 9.45936 8.65617C9.43812 8.67378 9.41703 8.69126 9.39616 8.7086C9.18465 8.88433 8.97594 9.06087 8.76955 9.26469L8.29521 9.73314L7.35832 8.78445L7.83266 8.316C8.08279 8.06898 8.32942 7.8614 8.54411 7.68303C8.56425 7.6663 8.58399 7.64992 8.60334 7.63386C8.79803 7.47229 8.95362 7.34318 9.08693 7.21349C9.35822 6.94958 9.45102 6.76686 9.45102 6.51215C9.45102 5.86102 8.92317 5.33317 8.27204 5.33317Z",
    fill: "#697180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61442 10.6665H8.95442V11.9998H7.61442V10.6665Z",
    fill: "#697180"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.967773 7.99984C0.967773 3.94975 4.25102 0.666504 8.30111 0.666504C12.3512 0.666504 15.6344 3.94975 15.6344 7.99984C15.6344 12.0499 12.3512 15.3332 8.30111 15.3332C4.25102 15.3332 0.967773 12.0499 0.967773 7.99984ZM8.30111 1.99984C4.9874 1.99984 2.30111 4.68613 2.30111 7.99984C2.30111 11.3135 4.9874 13.9998 8.30111 13.9998C11.6148 13.9998 14.3011 11.3135 14.3011 7.99984C14.3011 4.68613 11.6148 1.99984 8.30111 1.99984Z",
    fill: "#697180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_75700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.301758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question_circle.7918205463f08465e47222bc0c0101e6.svg";
export { ForwardRef as ReactComponent };